export default __webpack_public_path__ + "static/media/FincantieriSI_NavyLSS-DCSystems_Giugno2020.8c6513fb.pdf";